import { render, staticRenderFns } from "./HelloWorld2.vue?vue&type=template&id=b085efd4&scoped=true&lang=pug"
import script from "./HelloWorld2.vue?vue&type=script&lang=js"
export * from "./HelloWorld2.vue?vue&type=script&lang=js"
import style0 from "./HelloWorld2.vue?vue&type=style&index=0&id=b085efd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b085efd4",
  null
  
)

export default component.exports